import { temperatureUnit } from '../../utils/temperature';

export const MEASUREMENT_META = {
  pm_ae_2_5: { label: 'PM2.5', unit: 'µg/m³' },
  pm_ae_1_0: { label: 'PM1.0', unit: 'µg/m³' },
  pm_ae_10_0: { label: 'PM10', unit: 'µg/m³' },
  co2: { label: 'CO₂', unit: 'ppm' },
  temp: { label: 'Temp', unit: '°C' },  // see metaFor: the account can ask for °F
  humidity: { label: 'Humidity', unit: '%' },
  co_ppm: { label: 'CO', unit: 'ppm' },
  nox: { label: 'NOx', unit: 'index' },
  merc_ppm: { label: 'Mercaptan', unit: 'ppm' },
  tvoc: { label: 'TVOC', unit: 'ppm' },
  voc_index: { label: 'VOC Index', unit: 'index' },
  hcho: { label: 'HCHO', unit: 'ppm' },
  // SEN66 number concentration, cumulative "smaller than X um". A different
  // quantity and unit from the PTQS1005's "larger than X um per 100 cm³"
  // counts, so these get their own keys rather than reusing pc_*.
  nc_0_5: { label: '≤0.5µm', unit: '#/cm³' },
  nc_1_0: { label: '≤1.0µm', unit: '#/cm³' },
  nc_2_5: { label: '≤2.5µm', unit: '#/cm³' },
  nc_4_0: { label: '≤4.0µm', unit: '#/cm³' },
  nc_10_0: { label: '≤10µm', unit: '#/cm³' },
};

const PREFERENCE = ['pm_ae_2_5', 'co2'];

/**
 * [useFahrenheit] only ever moves the temperature channel. It is the account's
 * display setting, so the unit named here has to match what the caller plotted.
 */
export function metaFor(field, useFahrenheit = false) {
  const meta = MEASUREMENT_META[field] || { label: field, unit: '' };
  if (field !== 'temp') return meta;
  return { ...meta, unit: temperatureUnit(useFahrenheit) };
}

export function availableMeasurements(readings) {
  const keys = new Set();
  (readings || []).forEach((r) => Object.keys(r).forEach((k) => { if (k !== 't') keys.add(k); }));
  return Array.from(keys).sort();
}

export function defaultMeasurement(fields) {
  if (!fields || fields.length === 0) return null;
  const pref = PREFERENCE.find((p) => fields.includes(p));
  return pref || fields[0];
}
